import { useEffect, useState } from "react";
import { Row, Col } from "antd";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../CheckoutForm/index";
import { loadStripe } from "@stripe/stripe-js";
import { Get } from "../../config/api/get";
import { PAYMENT } from "../../config/constants/api";
import { Post } from "../../config/api/post";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import PaymentMethods from "../../components/paymentMethods";
import "./payment.css";
import PaymentComponent from "../../components/PaymentComponent";
function Payment(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const total = location?.state?.total;
  const type = location?.state?.type;
  const bookingId = location?.state?.bookingId;
  const planId = location?.state?.planId;
  const plan = location?.state?.plan;
  const details = location?.state?.details;
  const serviceType = location?.state?.serviceType;
  const passengerCapacity = location?.state?.passengerCapacity;
  const [stripePromise, setStripePromise] = useState(null);
  const [clientSecret, setClientSecret] = useState("");
  const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState(null);
  const [paymentProfileId , setPaymentProfileId] = useState(null);
  const [paymentMethods, setPaymentMethods] = useState(null);
  const token = useSelector((state) => state.user.userToken);

  const handleCardSelect = (paymentProfileId) => {
    setPaymentProfileId(paymentProfileId);
  };
  // const token = useSelector((state) => state.user.userToken);
  // useEffect(() => {
  //   if (!total) {
  //     navigate(-1);
  //   }
  //   Get(PAYMENT.paymentConfig, token)
  //     .then((response) => {
  //       const publishableKey = response.data?.publishableKey;
  //       setStripePromise(loadStripe(publishableKey));
  //     })
  //     .catch((err) => {
  //       console.log(err, "err");
  //     });
  // }, []);
  const getPaymentProfiles = async () => {
    Get(PAYMENT.getPaymentProfiles, token)
    .then((response) => {
      if (response?.status) {
          setPaymentMethods(response?.data?.paymentProfiles);
        }
      })
      .catch((err) => {
        console.log(err, "Error fetching payment methods");
      });
  };
  useEffect(() => {
      getPaymentProfiles();
  }, []);
  // useEffect(() => {
  //   let body = {
  //     amount: total,
  //     currency: "USD",
  //   };
  //   Post(PAYMENT.paymentIntent, body, token)
  //     .then((response) => {
  //       const clientSecret = response.data?.clientSecret;
  //       setPaymentMethods(response.data?.paymentMethods?.data);
  //       setClientSecret(clientSecret);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  return (
    <div style={{ overflow: "hidden" }}>
      <Row gutter={[16, 16]} justify={"center"} align={"middle"}>
        <Col lg={24} style={{ textAlign: "center", padding: "20px 0" }}>
          <h1
            className="font-bold font-goldman xldesktop:text-[22px] laptop:text-[16px] "
            style={{ color: "white" }}
          >
            CHECKOUT & PAYMENT
          </h1>
        </Col>
        <Col lg={17}>
          {Array.isArray(paymentMethods) && paymentMethods?.length > 0 && (
            <PaymentMethods
              paymentMethods={paymentMethods}
              onSelect={handleCardSelect}
            />
          )}
          <div className="payment-page-flex-div">
            {plan && (
              <div
                className="card-item-flex member-cards member-card-center"
                style={{
                  cursor: "pointer",
                  border: "2px solid #fff",
                  padding: "10px",
                  borderRadius: "12px",
                  // width: "80%",
                  fontWeight: "bold",
                  boxShadow: "1px 2px 2px #fff",
                  color: "white",
                }}
              >
                <h5 className="font-goldman text-customGold xldesktop:text-[22px] laptop:text-[16px] leading-8 font-semibold">
                  {plan?.title}
                </h5>
                <p>
                  {" "}
                  {plan?.hoursType} Hours Included : {plan?.hours} hours
                </p>
                <p>
                  Each Booking Duration : {plan?.bookingDuration} hours (one
                  booking)
                </p>
                <h4 className="font-goldman text-customGold xldesktop:text-[24px] laptop:text-[24px] leading-10 font-semibold">
                  To Pay : ${details?.discountedRate}
                </h4>
              </div>
            )}
            <div className="payment-body">
              {/* {clientSecret && stripePromise && (
                <Elements stripe={stripePromise} options={{ clientSecret }}>
                  <CheckoutForm
                    amount={total}
                    selectedPaymentMethodId={selectedPaymentMethodId}
                    clientSecret={clientSecret}
                    type={type}
                    bookingId={bookingId}
                    planId={planId}
                  />
                </Elements>
                )} */}
              <PaymentComponent
                amount={total}
                type={type}
                bookingId={bookingId}
                planId={planId}
                paymentProfileId={paymentProfileId}
                details={details}
                serviceType={serviceType}
                passengerCapacity={passengerCapacity}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Payment;
